export enum ProspectsActionKeys {
  ACTIVATE_PROSPECT = 'ACTIVATE_PROSPECT',
  CHANGE_LIFECYCLE_STEP = 'CHANGE_LIFECYCLE_STEP',
  CHANGE_LIFECYCLE_STEP_FULFILLED = 'CHANGE_LIFECYCLE_STEP_FULFILLED',
  CHANGE_LIFECYCLE_STEP_PENDING = 'CHANGE_LIFECYCLE_STEP_PENDING',
  CHANGE_LIFECYCLE_STEP_REJECTED = 'CHANGE_LIFECYCLE_STEP_REJECTED',
  CREATE_PROSPECT = 'CREATE_PROSPECT',
  DEACTIVATE_PROSPECT = 'DEACTIVATE_PROSPECT',
  FETCH_PROSPECT = 'FETCH_PROSPECT',
  FETCH_PROSPECT_PENDING = 'FETCH_PROSPECT_PENDING',
  FETCH_PROSPECT_REJECTED = 'FETCH_PROSPECT_REJECTED',
  FETCH_PROSPECTS = 'FETCH_PROSPECTS',
  FETCH_PROSPECTS_PENDING = 'FETCH_PROSPECTS_PENDING',
  FETCH_PROSPECTS_REJECTED = 'FETCH_PROSPECTS_REJECTED',
  FREEZE_PROSPECT = 'FREEZE_PROSPECT',
  HIDE_PROSPECTS_LOADING = 'HIDE_PROSPECTS_LOADING',
  SAVE_COMPLETE = 'SAVE_COMPLETE',
  SET_PROSPECT_TOTAL_ITEMS = 'SET_PROSPECT_TOTAL_ITEMS',
  SET_PROSPECTS = 'SET_PROSPECTS',
  SHOW_PROSPECTS_LOADING = 'SHOW_PROSPECTS_LOADING',
  THAW_PROSPECT = 'THAW_PROSPECT',
  UPDATE_PROSPECT = 'UPDATE_PROSPECT',
  UPDATE_PROSPECT_FULFILLED = 'UPDATE_PROSPECT_FULFILLED',
  UPDATE_PROSPECT_PENDING = 'UPDATE_PROSPECT_PENDING',
  UPDATE_PROSPECT_REJECTED = 'UPDATE_PROSPECT_REJECTED'
}
